/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { EventGroup } from '@app/events/events-groups/event-group.model';
import { Model } from '@app/shared/models/model.model';

@Injectable({
  providedIn: 'root',
})
export class EventGroupsService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/event_groups', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((eventGr: any) => {
          return new EventGroup().deserialize(eventGr);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(eventGroup: EventGroup): Observable<EventGroup> {
    return this.http.put('v1/event_groups/' + eventGroup.id, eventGroup).pipe(
      map((response: HttpResponse) => {
        return new EventGroup().deserialize(response.data);
      })
    );
  }

  store(eventGroup: EventGroup): Observable<EventGroup> {
    return this.http.post('v1/event_groups', eventGroup).pipe(
      map((response: HttpResponse) => {
        return new EventGroup().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/event_groups/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new EventGroup().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/event_groups/' + id);
  }

  updateTranslations(eventGroup: EventGroup, translations: any): Observable<any> {
    return this.http.put('v1/event_groups/translations/' + eventGroup.id, translations).pipe(
      map((response: HttpResponse) => {
        return response;
      })
    );
  }
}
